import { GraphQLFormattedError } from 'graphql'

import { graphQLErrorsList } from '@/models/error'

// Set query or mutation request error
interface RequestProps {
  graphQLErrors?: ReadonlyArray<GraphQLFormattedError>
  networkError?: Error | null
}

function convertConstantToReadableString(str: string) {
  // Convert to lowercase
  const lower = str.toLowerCase()

  // Replace underscores with spaces
  const spaced = lower.replace(/_/g, ' ')

  // Capitalize the first letter
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

export const getGraphQLErrorMessage = (code: string, message: string): string => {
  if (graphQLErrorsList.includes(code)) {
    return `validation.error.${code}`
  }

  if (code && message) {
    return message ?? convertConstantToReadableString(code)
  }

  return 'global.network_error'
}

export const setRequestError = (
  { networkError, graphQLErrors }: RequestProps,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>,
  { withTimeout }: { withTimeout: boolean } = { withTimeout: true },
): void => {
  if (networkError) {
    setErrorMessage('global.network_error')
    withTimeout && setTimeout(() => setErrorMessage(''), 5000)

    return
  }
  if (graphQLErrors?.length) {
    const errorCode = graphQLErrors[0].extensions?.code
    const message = graphQLErrors[0].extensions?.message

    setErrorMessage(getGraphQLErrorMessage(errorCode, message))
    withTimeout && setTimeout(() => setErrorMessage(''), 5000)

    return
  }

  return
}

export const getRequestError = ({ networkError, graphQLErrors }: RequestProps): string => {
  if (networkError) {
    return 'global.network_error'
  }

  if (graphQLErrors?.length) {
    const errorCode = graphQLErrors[0].extensions?.code
    const message = graphQLErrors[0].extensions?.message

    return getGraphQLErrorMessage(errorCode, message)
  }

  return null
}
